import { ModelClass } from '../models';
import { useAppSelector } from '../../store/hooks';
import { orderBy } from '../../utils';
import { getModelMap } from '../slice';
import { useEffect } from 'react';
import { DictRequestStatusDisplay } from '../../features/CommonComponents';
import { Select } from '../../features/RequestRespectingInputs';

/** A reusable component that shows a dropdown with all objects of a given type. */
export function RestObjectDDL(props: Props)
{
    const models = getModelMap(useAppSelector, props.modelClass);
    useEffect(function()
    {
        if (models && !props.hasEmptyOption && !props.selection)
        {
            const models2 = Object.values(models)
            const models3 = orderBy(models2, (m: any) => m[props.property]);
            props.handleChange(models3?.[0]?.key || '');
        }
    }, [models, props]);

    if (models == null)
    {
            return <DictRequestStatusDisplay modelClass={props.modelClass} />;
    }
    else
    {
        const models2 = Object.values(models)
        const models3 = orderBy(models2, (m: any) => m[props.property]);

        const emptyOption = props.hasEmptyOption ? <option key=''></option> : <></>;
        const otherOptions = models3.map(function(eam: any)
        {
            return <option key={eam.key} value={eam.key}>{eam[props.property]}</option>;
        });

        const items =(
        <>
            {emptyOption}
            {otherOptions}
        </>);

        return (
        <Select
                id={props.id}
                name={props.name}
                onChange={e => props.handleChange(e.currentTarget.value)}
                value={props.selection ?? ''}
                required={props.required}>
            {items}
        </Select>);
    }
}

interface Props
{
    id?: string;
    name?: string;
    /** The ModelClass of the objects. */
    modelClass: ModelClass;
    /** property - The name of the property used for item values (the key is always "key"). */
    property: string;
    /** Whether to show an empty option at the top. */
    hasEmptyOption: boolean;
    /** The value of the selected item. */
    selection?: string;
    /** Whether it's a required field. */
    required?: boolean;

    handleChange: ((newValue: string) => void)
}